export default {
  url: "https://api.pulse-experience.co",
  // url: "http://localhost",
  clientId: "8puWuJWZYls1Ylawxm6CMiYREhsGGSyw"
};
//url: 'http://10.18.197.246:8080',
